<template>
  <OrderOverviewPage
    i18n-prefix="takeawayOrder"
    config-key="TAKEAWAY_ORDER"
    :retrieve-order-options="retrieveOrderOptions"
  />
</template>

<script>
import OrderOverviewPage from "@/components/page-components/Order/OrderOverviewPage.vue";
import {Order} from "@/constants/constants";

export default {
  name: 'TakeawayOrder',
  components: {
    OrderOverviewPage,
  },
  data() {
    return {
      retrieveOrderOptions: {
        orderTypeId: Order.orderTypId.TAKEAWAY,
      },
    };
  },
}
</script>


